module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/11-4b3260a030d4df9f14b111ce714b9e8a.jpg";